import React from 'react';
import Head from './components/Head';
import Main from './components/Main';
import Footer from './components/Footer';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Head />
      <Router>
        <Routes>
          {/* Rota padrão com preço de 29,90 */}
          <Route path="/" element={<Main price="29,90" link="https://dub.sh/truquescheckout"/>} />
          {/* Rota alternativa com preço de 27,90 */}
          <Route path="/oferta" element={<Main price="27,90" link="https://dub.sh/truquescheckout" />} />
        </Routes>
      </Router>
      <Footer />
    </div>
  );
}

export default App;
